import { ModalLayout } from '@/components/ModalLayout'
import { TaskHeaderLeft } from '@/components/TaskHeaderLeft'
import { Button, Modal, Toast } from '@seiue/ui'
import { SchoolPluginScope, reflectionApi } from 'packages/sdks-next/growp'
import { EntryComponentsWrapper } from 'packages/theme'
import { useState } from 'react'

import { SelectReflectionContent } from '../../../components/SelectReflectionContent'

/**
 * 应用编辑 - 选人弹窗
 *
 * @param param - 参数
 * @param param.onClose - 关闭方法
 * @param param.scopes - 插件用户范围
 * @param param.setScopes - 设置插件用户范围
 * @param param.setSelectNames -设置当前已选用户名称
 * @returns 组件
 */
export const SelectReflectionModal: React.FC<{
  onClose: () => void
  scopes: SchoolPluginScope
  setScopes: (data: SchoolPluginScope) => void
  setSelectNames: (data: string[]) => void
}> = ({ onClose, scopes, setScopes, setSelectNames }) => {
  const oriScopes = { ...scopes }
  const [isChange, setIsChange] = useState(false)
  const [selectedIds, setSelectedIds] = useState<number[]>(scopes.ids)

  return (
    <EntryComponentsWrapper>
      <ModalLayout
        title={
          <TaskHeaderLeft
            title="选择授权成员"
            onClose={onClose}
          />
        }
        headerRight={
          <>
            <Button
              type="gray"
              style={{ marginRight: '12px' }}
              onClick={() => {
                if (!isChange) {
                  onClose()
                  return
                }

                Modal.confirm({
                  title: '确认离开该界面吗?',
                  content:
                    '正在离开该界面，离开后修改数据不会保存，确认离开吗？',
                  onOk: () => {
                    setScopes(oriScopes)
                    onClose()
                  },
                })
              }}
            >
              {'取消'}
            </Button>
            <Button
              type="primary"
              style={{ marginRight: 0 }}
              onClick={async () => {
                if (selectedIds.length === 0 || !isChange) {
                  onClose()
                  return
                }

                const { data } = await reflectionApi.countReflections({
                  idIn: selectedIds.join(','),
                })
                setSelectNames(data.names)

                Toast.success('已成功添加成员')
                onClose()
              }}
            >
              {'确定'}
            </Button>
          </>
        }
        contentStyle={{
          padding: '20px 120px',
          height: 'calc(100vh - 72px)',
          overflow: 'auto',
        }}
        content={
          <SelectReflectionContent
            scopes={scopes}
            setScopes={setScopes}
            setIsChange={setIsChange}
            setSelectedIds={setSelectedIds}
          />
        }
      />
    </EntryComponentsWrapper>
  )
}
